import React from "react";
import { Box, Typography } from "@mui/material";

const Privacy = () => (
  <Box sx={{ padding: 4, textAlign: "left" }}>
    <Typography variant="h4" gutterBottom color="primary">
      Datenschutzerklärung
    </Typography>
    <Typography variant="body1" color="text.secondary">
      <strong>1. Verantwortlicher</strong><br />
      Scivola<br />
      Stumpergasse 2/13<br />
      1060 Wien<br /><br />

      Vertretungsberechtigte: Maximilian Kröpfl, Paul von Hirschhausen, Maximilian Zimmer<br />
      Telefon: +49 177 4891822<br />
      E-Mail: mk@maxdoes.law<br /><br />

      <strong>2. Allgemeines zur Datenverarbeitung</strong><br />
      Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021 bzw. TTDSG).<br /><br />

      <strong>3. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung</strong><br />
      Beim Besuch dieser Website werden folgende Informationen automatisch erfasst (Server-Logfiles): IP-Adresse, Datum und Uhrzeit der Anfrage, Name und URL der abgerufenen Datei, Website, von der aus der Zugriff erfolgt (Referrer-URL), verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers. Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses zur Sicherstellung der Systemsicherheit.<br /><br />

      <strong>4. Cookies</strong><br />
      Unsere Website verwendet Cookies. Dabei handelt es sich um kleine Textdateien, die auf Ihrem Endgerät gespeichert werden. Notwendige Cookies dienen der Funktionalität der Website und werden ohne Einwilligung gesetzt. Andere Cookies (z. B. für Analysezwecke) werden nur mit Ihrer Einwilligung verwendet (Art. 6 Abs. 1 lit. a DSGVO). Sie können Ihre Cookie-Einstellungen jederzeit anpassen.<br /><br />
      <strong>Cookie-Einstellungen</strong><br />
      Beim ersten Besuch der Website wird ein Cookie-Banner angezeigt, das Sie über die Verwendung von Cookies informiert. Sie können Ihre Präferenzen direkt im Banner auswählen oder später über die Cookie-Einstellungen ändern.<br /><br />

      <strong>5. Kontaktaufnahme</strong><br />
      Wenn Sie per E-Mail Kontakt mit uns aufnehmen, werden Ihre Angaben zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen gespeichert. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen).<br /><br />

      <strong>6. Weitergabe von Daten</strong><br />
      Eine Übermittlung Ihrer personenbezogenen Daten an Dritte findet grundsätzlich nicht statt, außer es besteht eine gesetzliche Verpflichtung oder dies ist zur Vertragserfüllung erforderlich. Hosting-Dienstleister erhalten Zugriff auf Daten im Rahmen der Auftragsverarbeitung gemäß Art. 28 DSGVO.<br /><br />

      <strong>7. Speicherdauer</strong><br />
      Personenbezogene Daten werden nur so lange gespeichert, wie dies für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.<br /><br />

      <strong>8. Drittstaatenübermittlung</strong><br />
      Wenn Dienste von Anbietern mit Sitz in einem Drittland (z. B. USA) verwendet werden, erfolgt die Übermittlung nur, wenn ein angemessenes Datenschutzniveau besteht oder Standardvertragsklauseln abgeschlossen wurden.<br /><br />

      <strong>9. Ihre Rechte</strong><br />
      Sie haben das Recht auf Auskunft über Ihre gespeicherten Daten, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung (Art. 15–21 DSGVO). Bitte wenden Sie sich hierzu an mk@maxdoes.law.<br /><br />

      <strong>10. Beschwerderecht</strong><br />
      Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen geltendes Datenschutzrecht verstößt, steht Ihnen ein Beschwerderecht bei der Aufsichtsbehörde zu. In Österreich: Österreichische Datenschutzbehörde, Barichgasse 40-42, 1030 Wien. In Deutschland: Die jeweils zuständige Landesdatenschutzbehörde Ihres Bundeslands.<br /><br />

      <strong>11. Änderungen</strong><br />
      Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, um sie an aktuelle rechtliche Anforderungen anzupassen.<br /><br />

      Stand: April 2025
    </Typography>
  </Box>
);

export default Privacy;
